import {PushNotifications} from "@capacitor/push-notifications";
import {JsonObject} from "@/shared/json/json-object";
import {BaseListItem, BaseListItemsLoader} from "@/shared/types";
import {FormGen} from "@/shared/formgen";
import {JsonProperty} from "@/shared/json/json-property";
import {JSON_OBJECT} from "@/shared/json/helpers";
import {SharedPrefs} from "../SharedPrefs";
import {getMemberAuth} from "../../shared/auth";

@JsonObject()
export class Token extends BaseListItem {

  @FormGen({name: "Token", type: "string"})
  @JsonProperty()
  token: string;

  @JsonProperty()
  registered: number;

  static createNew(deviceId: string, token: string): Token {
    return new Token(deviceId, getMemberAuth().getMemberId(), Date.now(), token);
  }

  constructor(id: string, creator: string, created: number, token: string) {
    super(id, creator, created);
    this.token = token;
    this.registered = created;
  }
}

export class Tokens extends BaseListItemsLoader<Token> {

  private static instance: Tokens;

  static getInstance(): Tokens {
    if (!this.instance) {
      this.instance = new Tokens();
    }
    return this.instance;
  }

  private constructor() {
    super({shared: true, scopeRoot: true});
  }

  async loadListItems(): Promise<void> {
    throw new Error("Not allowed.");
  }

  protected basePath(): string {
    return "tokens";
  }

  protected deserializeItem(value: any): Token {
    return JSON_OBJECT.deserializeObject(value, Token);
  }

  protected serializeItem(item: Token): any {
    return JSON_OBJECT.serializeObject(item);
  }

  protected sortOrder(item1: Token, item2: Token): number {
    return item2.created - item1.created;
  }
}


export class NotificationService {

  private static instance: NotificationService;

  static getInstance(): NotificationService {
    if (!this.instance) {
      this.instance = new NotificationService();
    }
    return this.instance;
  }

  private constructor() {
  }

  async registerNotifications(): Promise<void> {
    let permStatus = await PushNotifications.checkPermissions();
    console.log('Registration status: ', permStatus);

    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions();
    }

    // If permission is denied, throw an error
    if (permStatus.receive !== 'granted') {
      throw new Error('User denied permissions!');
    }

    await PushNotifications.register(); // Register the device for push notifications
  };

  async addListeners(): Promise<void> {
    const tokens = Tokens.getInstance();
    const sharedPrefs = SharedPrefs.getInstance();
    const storedNotificationIds = []

    // Register for push notification registration event
    await PushNotifications.addListener('registration', (tokenId) => {
      const deviceId = sharedPrefs.getClientId();
      console.info('Registration token: ', tokenId.value);

      // Create and store the token
      const token = Token.createNew(deviceId, tokenId.value);
      tokens.addListItem(token);
    });

    // Handle push notification registration errors
    await PushNotifications.addListener('registrationError', (err) => {
      alert(err)
      console.error('Registration error: ', err.error);
    });

    // Push notification received event (foreground)
    await PushNotifications.addListener('pushNotificationReceived', (notification) => {
      if (storedNotificationIds.includes(notification.data.id)) {
        console.log('Notification with this ID has already been shown.');
        return;
      }
      if (notification.data.id) {
        storedNotificationIds.push(notification.data.id);
        this.showLocalNotification(notification.data.title, notification.data.text, notification.data.id)
      }
      console.log('Push notification received: ', JSON.stringify(notification.data));
    });

    // Push notification action performed event (background/foreground action)
    await PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
      console.log('Push notification action performed', notification.actionId, notification.inputValue);
    });
  };

  private async showLocalNotification(title: string, body: string, notificationId: string): Promise<void> {
    try {
      // // Get the list of pending notifications
      // const pendingResult = await LocalNotifications.getPending();
      // const pendingNotifications = pendingResult.notifications;  // This is the array we need to check
      //
      // // Check if the notification with the same ID is already pending
      // const isAlreadyScheduled = pendingNotifications.some(notification => notification.id === parseInt(notificationId));
      //
      // if (isAlreadyScheduled) {
      //   console.log('Notification with this ID is already scheduled.');
      //   return; // Skip scheduling this notification again
      // }
      //
      // // If not already scheduled, create and store the notification
      // const notificationList = Notifications.getInstance();
      // const notifications = await notificationList.getOrLoadListItems();
      //
      // const notification = new Notification(notificationId, null, null);
      // notification.title = title;
      // notification.text = body;
      // await notificationList.addListItem(notification);
      //
      // // Schedule the notification
      // await LocalNotifications.schedule({
      //   notifications: [
      //     {
      //       title: title,
      //       body: body,
      //       id: parseInt(notificationId),  // Ensure the ID is an integer
      //       schedule: {at: new Date(Date.now() + 1000)}, // Schedule it 1 second later
      //       sound: 'default', // Default sound for the notification
      //     },
      //   ],
      // });
      console.log('Local notification scheduled:', title, body);
    } catch (error) {
      console.error('Error scheduling local notification:', error);
    }
  }
}